export const formatPrice = (
  price = 0,
  locale: string,
  currency: string,
  shouldIncludeDecimals = true
) => {
  const fractions = !shouldIncludeDecimals
    ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
    : {};
  return price.toLocaleString(locale, {
    style: 'currency',
    currency,
    ...fractions,
  });
};
